import { connect } from "react-redux";
import compOperations from "../comp/ducks/operations";
import RequestModal from "./RequestModal";
import operations from "./ducks/operations";

const RequestModalContainer = (props) => {
    return <RequestModal {...props} autocompleteResults={props.autocompleteResults} />;
};

const mapStateToProps = (state) => {
    return {
        role: state.authReducer.userProfile.role,
        user: state.authReducer.userProfile.user,
        isLoading: state.utilsReducer.isLoading,
        searchResults: state.searchReducer.autocompleteResults,
        autocompleteResults: state.searchReducer.autocompleteResults,
        requestModal: state.listingReducer.requestModal,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        selectProperty: (property) => {
            dispatch(operations.getPropertyForListingCreation(property));
        },
        removeSelectedProperty: () => {
            dispatch(operations.removeSelectedPropertyFromRequestModal());
        },
        updateListingRequest: (field, value) => {
            dispatch(operations.updateListingRequest(field, value));
        },
        requestListing: async (modalType, transactionType, propertyType, tab, navigate) => {
            let result = undefined;
            switch (modalType) {
                case "listing":
                    if (tab === "existing") {
                        result = await dispatch(operations.requestListing());
                    } else {
                        result = await dispatch(operations.requestListingNewProperty());
                    }

                    if (result?.entityKey) {
                        navigate(`/listing/${result.entityKey}`);
                    }

                    break;
                case "appraisal":
                    result = await dispatch(
                        compOperations.createComp(transactionType, propertyType, tab === "new", "Appraisal Draft")
                    );

                    if (result?.entityKey) {
                        navigate(
                            transactionType === "Consulting"
                                ? `/voucher/${result.entityKey}`
                                : `/comp/${result.entityKey}`
                        );
                    }

                    break;
                case "outside-comp":
                    result = await dispatch(
                        compOperations.createComp(transactionType, propertyType, tab === "new", "Outside Draft", true)
                    );

                    if (result?.entityKey) {
                        navigate(`/comp/${result.entityKey}`);
                    }

                    break;
                case "internal-comp":
                    result = await dispatch(
                        compOperations.createComp(transactionType, propertyType, tab === "new", "Draft")
                    );

                    if (result?.entityKey) {
                        navigate(
                            transactionType === "Consulting"
                                ? `/voucher/${result.entityKey}`
                                : `/comp/${result.entityKey}`
                        );
                    }

                    break;
                default:
                    break;
            }
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestModalContainer);
